var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"card-container"},[_c('iframe',{ref:"myIframe",attrs:{"src":"https://t.guanyingtang.com/profile/psxk.html","width":"100%","height":"1900px","frameborder":"0"},on:{"load":_vm.adjustHeight}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }